import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { ConfigService } from '../../../../utils/config-service';
import { formatDate } from '../../../../utils/date-format';
import { HistogramData } from '../../models/histogramData';

@Injectable()
export class HistogramApiService {
    private histogramUrl: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.histogramUrl = this.configService.getEnv('lineGraphApi');
    }

    getHistogram(jobId: string, date: Date, bin: number): Observable<{} | HistogramData> {
        let url = this.histogramUrl + jobId + '/histogram/' + formatDate(date) + '/' + bin;

        return this.http.get(url)
            .map((result: any) => {
                let json = result;
                if (json) {
                    return new HistogramData(json);
                }
            })
            .catch((error: any) => {
                throw error;
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/histogram/histogram.api.service.ts